module.exports = __webpack_public_path__ + "static/img/lres10.5ec532b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lres10.png
// module id = vkxn
// module chunks = 1